import React, { useMemo } from "react";
import { Button, Dropdown, Form, FormField, FormGroup, Input, TextArea } from "semantic-ui-react";
//STYLE
import "react-lib/apps/HISV3/common/CardOrderSetTemplate.scss";
import { Table } from "react-lib/frameworks/Table";
import TimeFreeTextBox24 from "react-lib/apps/common/TimeFreeTextBox24";
import {
  eligibilityTypeOptions,
  MasterOptionsType,
  OptionType,
  OrderSetTemplateType,
  SelectDetailType,
  SetProp,
  supplyMode,
  urgencyOptions,
} from "./sequence/OrderSetTemplate";

const toBePerformerOption = [
  { key: 1, value: 1, text: "Doctor" },
  { key: 2, value: 2, text: "Nurse" },
  { key: 3, value: 3, text: "Other" },
];

const supplyOrderType = [
  { key: 1, value: 1, text: "HOME_OPD" },
  { key: 2, value: 2, text: "HOME_IPD" },
  { key: 3, value: 3, text: "REFILL_OPD" },
  { key: 4, value: 4, text: "REFILL_IPD" },
  { key: 6, value: 6, text: "STAT" },
  { key: 7, value: 7, text: "COST_CENTER" },
  { key: 8, value: 8, text: "ONE_DAY" },
];

type FormMobEditOrderDetailProps = {
  runSequence: (e: any) => any;
  setProp: SetProp;
  selectedData?: Record<string, any>;
  OrderSetTemplateSequence?: OrderSetTemplateType;
  // options
  masterOptions?: MasterOptionsType;
  masterData?: MasterOptionsType;
  supplyOrderEligibilityOptions?: any[];
};

const FormMobEditOrderDetail = (props: FormMobEditOrderDetailProps) => {
  const selectDetail = props.OrderSetTemplateSequence?.selectDetail;

  const searchIcd9Data = useMemo(() => {
    return (props.OrderSetTemplateSequence?.searchIcd9 || [])?.map((item: any) => {
      return item;
    });
  }, [props.OrderSetTemplateSequence?.searchIcd9]);

  const handleChangeData = (e: any, v: any) => {
    let value = v.type === "checkbox" ? v.checked : v.value;

    props.setProp(
      `OrderSetTemplateSequence.selectDetail.${v.name as keyof SelectDetailType}`,
      v.name === "quantity" ? Number(value.replace(/\D/g, "")) : value
    );
  };

  const handleSearchICD9 = () => {
    props.runSequence({
      sequence: "OrderSetTemplate",
      action: "searchIcd9",
    });
  };

  const handleSelectedICD9Data = (data: any) => {
    props.setProp(`OrderSetTemplateSequence`, {
      ...props.OrderSetTemplateSequence,
      selectDetail: {
        ...props.OrderSetTemplateSequence?.selectDetail,
        icd9: data,
      },
      searchIcd9: [],
    });
  };

  return (
    <div style={{ margin: "20px" }}>
      {selectDetail?.p_type_code === "PROC" ? (
        <Form>
          <FormGroup
            inline
            style={{
              display: "flex",
            }}
          >
            <FormField inline>
              <label
                style={{ fontWeight: "bold", fontSize: "14px", margin: "10px 0px" }}
              >{`[${selectDetail?.code}] ${selectDetail?.name}`}</label>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>QTY</label>
            </FormField>
            <FormField width={10}>
              <Input
                value={selectDetail?.quantity}
                fluid
                name="quantity"
                onChange={handleChangeData}
              />
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>Eligibility type</label>
            </FormField>
            <FormField width={10}>
              <Dropdown
                fluid={true}
                onChange={handleChangeData}
                options={eligibilityTypeOptions}
                search={true}
                selection={true}
                name="eligibility_type"
                value={selectDetail?.eligibility_type}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>ระบุ ICD9</label>
            </FormField>
            <FormField width={10}>
              <Input
                value={selectDetail?.icd9?.icdterm}
                fluid
                name="icd9.icdterm"
                onChange={handleChangeData}
              />
              <div
                style={{
                  display: searchIcd9Data?.length === 0 ? "none" : "block",
                  zIndex: 100,
                }}
              >
                <Table
                  data={searchIcd9Data}
                  getTrProps={(state: any, rowInfo: any, column: any, instance: any) => {
                    return {
                      onClick: () => {
                        handleSelectedICD9Data(rowInfo.original);
                      },
                    };
                  }}
                  keys="medterm,icdterm,icdcode"
                  minRows="4"
                  showPagination={false}
                  style={{ height: "150px" }}
                ></Table>
              </div>
            </FormField>
            <FormField width={3}>
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Button color="blue" size="small" onClick={handleSearchICD9}>
                  ค้นหา ICD9
                </Button>
              </div>{" "}
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>ผู้ทำหัตถการ</label>
            </FormField>
            <FormField width={10}>
              <Dropdown
                fluid={true}
                onChange={handleChangeData}
                options={toBePerformerOption}
                search={true}
                selection={true}
                name="to_be_performer"
                value={selectDetail?.to_be_performer}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>รายละเอียดเพิ่มเติม</label>
            </FormField>
            <FormField width={10}>
              <TextArea
                value={selectDetail?.order_detail}
                fluid
                name="order_detail"
                onChange={handleChangeData}
                style={{ width: "100%", height: "100%", border: "solid #cccccc 1px" }}
              ></TextArea>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>อุปกรณ์</label>
            </FormField>
            <FormField width={10}>
              <TextArea
                value={selectDetail?.equipment_detail}
                fluid
                name="equipment_detail"
                onChange={handleChangeData}
                style={{ width: "100%", height: "100%", border: "solid #cccccc 1px" }}
              ></TextArea>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>Remark</label>
            </FormField>
            <FormField width={10}>
              <TextArea
                value={selectDetail?.remark}
                fluid
                name="remark"
                onChange={handleChangeData}
                style={{ width: "100%", height: "100%", border: "solid #cccccc 1px" }}
              ></TextArea>
            </FormField>
          </FormGroup>
        </Form>
      ) : selectDetail?.p_type_code === "SUPPLY" ? (
        <Form>
          <FormGroup
            inline
            style={{
              display: "flex",
            }}
          >
            <FormField inline>
              <label
                style={{ fontWeight: "bold", fontSize: "14px", margin: "10px 0px" }}
              >{`[${selectDetail?.code}] ${selectDetail?.name}`}</label>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <div style={{ display: "flex", margin: "10px 0px" }}>
                <label style={{ fontWeight: "bold" }}>Mode</label>
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                  {selectDetail?.mode && selectDetail.mode in supplyMode
                    ? supplyMode[selectDetail.mode as keyof typeof supplyMode]
                    : ""}
                </div>
              </div>
            </FormField>
            <FormField width={1}></FormField>
            <FormField width={1}>
              <label style={{ margin: "10px 0px" }}>QTY</label>
            </FormField>
            <FormField width={3}>
              <Input
                value={selectDetail?.quantity}
                fluid
                name="quantity"
                onChange={handleChangeData}
              />
            </FormField>
            <FormField width={1}></FormField>
            <FormField width={4}>
              <div style={{ display: "flex", margin: "10px 0px" }}>
                <label style={{ fontWeight: "bold", width: "100%" }}>ขนาดบรรจุ</label>
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                  {selectDetail?.unit_name}
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>Supply type</label>
            </FormField>
            <FormField width={10}>
              <Dropdown
                fluid={true}
                onChange={handleChangeData}
                options={supplyOrderType}
                search={true}
                selection={true}
                name="type"
                value={selectDetail?.type}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>Eligibility type</label>
            </FormField>
            <FormField width={10}>
              <Dropdown
                fluid={true}
                onChange={handleChangeData}
                options={eligibilityTypeOptions}
                search={true}
                selection={true}
                name="eligibility_type"
                value={selectDetail?.eligibility_type}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>Remark</label>
            </FormField>
            <FormField width={10}>
              <TextArea
                value={selectDetail?.remark}
                fluid
                name="remark"
                onChange={handleChangeData}
                style={{ width: "100%", height: "100%", border: "solid #cccccc 1px" }}
              ></TextArea>
            </FormField>
          </FormGroup>
        </Form>
      ) : selectDetail?.p_type_code === "LAB" ? (
        <Form>
          <FormGroup
            inline
            style={{
              display: "flex",
            }}
          >
            <FormField inline>
              <label
                style={{ fontWeight: "bold", fontSize: "14px", margin: "10px 0px" }}
              >{`[${selectDetail?.code}] ${selectDetail?.name}`}</label>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={8}>
              <div style={{ display: "flex", margin: "10px 0px" }}>
                <label style={{ fontWeight: "bold" }}>Specimen: </label>
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <div style={{ display: "flex" }}>
                    {selectDetail?.specimen_color && (
                      <div
                        style={{
                          backgroundColor: selectDetail?.specimen_color,
                          borderRadius: "50%",
                          width: "1.5em",
                          height: "1.5em",
                          margin: "0px 10px",
                        }}
                      ></div>
                    )}
                    {selectDetail?.specimen_code && (
                      <div>
                        {(props.masterData?.specimenList || [])?.filter(
                          (item) => item?.code === selectDetail?.specimen_code
                        )?.[0]?.name || ""}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </FormField>
            <FormField width={1}></FormField>
            <FormField width={4}>
              <div style={{ display: "flex", margin: "10px 0px" }}>
                <label style={{ fontWeight: "bold", width: "100%" }}>การส่งตรวจ: </label>
                <div style={{ display: "flex", justifyContent: "center", width: "100%" }}>
                  {selectDetail?.lab_type_label}
                </div>
              </div>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>Specimen time</label>
            </FormField>
            <FormField width={3}>
              <div style={{ display: "flex", height: "100%", width: "100%" }}>
                <TimeFreeTextBox24
                  className="time-custom-react-picker"
                  onChange={(value: string) => {
                    props.setProp("OrderSetTemplateSequence.selectDetail.specimen_time", value);
                  }}
                  value={selectDetail?.specimen_time}
                  iconClockStyle={{ margin: "auto 30px" }}
                  autoFocus={false}
                  checkTimeOverflow={true}
                ></TimeFreeTextBox24>
              </div>
            </FormField>
            <FormField width={2}></FormField>
            <FormField width={2}>
              <label style={{ margin: "10px 0px" }}>Urgency</label>
            </FormField>
            <FormField width={3}>
              <Dropdown
                fluid={true}
                onChange={handleChangeData}
                options={urgencyOptions}
                search={true}
                selection={true}
                name="urgency"
                value={Number(selectDetail?.urgency)}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>Note</label>
            </FormField>
            <FormField width={10}>
              <TextArea
                value={selectDetail?.note}
                fluid
                name="note"
                onChange={handleChangeData}
                style={{ width: "100%", height: "100%", border: "solid #cccccc 1px" }}
              ></TextArea>
            </FormField>
          </FormGroup>
        </Form>
      ) : selectDetail?.p_type_code === "XRAY" ? (
        <Form>
          <FormGroup
            inline
            style={{
              display: "flex",
            }}
          >
            <FormField inline>
              <label
                style={{ fontWeight: "bold", fontSize: "14px", margin: "10px 0px" }}
              >{`[${selectDetail?.code}] ${selectDetail?.name}`}</label>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={7}>
              <div style={{ display: "flex", margin: "10px 0px" }}>
                <label style={{ fontWeight: "bold" }}>X-ray Group </label>
                <div style={{ margin: "0px 10px" }}>{selectDetail?.xrayGroup}</div>
              </div>
            </FormField>
            <FormField width={1}></FormField>
            <FormField width={2}>
              <label style={{ margin: "10px 0px" }}>Eligibility</label>
            </FormField>
            <FormField width={6}>
              <Dropdown
                fluid={true}
                onChange={handleChangeData}
                options={eligibilityTypeOptions}
                search={true}
                selection={true}
                name="eligibility_type"
                value={selectDetail?.eligibility_type}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={2}>
              <label style={{ margin: "10px 0px" }}>QTY</label>
            </FormField>
            <FormField width={3}>
              <Input
                value={selectDetail?.quantity}
                fluid
                name="quantity"
                onChange={handleChangeData}
              />
            </FormField>
            <FormField width={3}></FormField>
            <FormField width={2}>
              <label style={{ margin: "10px 0px" }}>Urgency</label>
            </FormField>
            <FormField width={6}>
              <Dropdown
                fluid={true}
                onChange={handleChangeData}
                options={urgencyOptions}
                search={true}
                selection={true}
                name="urgency"
                value={Number(selectDetail?.urgency)}
              ></Dropdown>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={2}>
              <label style={{ margin: "10px 0px" }}>Note</label>
            </FormField>
            <FormField width={14}>
              <TextArea
                value={selectDetail?.note}
                fluid
                name="note"
                onChange={handleChangeData}
                style={{ width: "100%", height: "100%", border: "solid #cccccc 1px" }}
              ></TextArea>
            </FormField>
          </FormGroup>
        </Form>
      ) : (
        <Form>
          <FormGroup
            inline
            style={{
              display: "flex",
            }}
          >
            <FormField inline>
              <label
                style={{ fontWeight: "bold", fontSize: "14px", margin: "10px 0px" }}
              >{`[${selectDetail?.code}] ${selectDetail?.name}`}</label>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>QTY</label>
            </FormField>
            <FormField width={3}>
              <Input
                value={selectDetail?.quantity}
                fluid
                name="quantity"
                onChange={handleChangeData}
              />
            </FormField>
            <FormField width={4}>
              <div style={{ display: "flex", margin: "10px 0px" }}>{"ครั้ง"}</div>
            </FormField>
          </FormGroup>
          <FormGroup>
            <FormField width={3}>
              <label style={{ margin: "10px 0px" }}>Eligibility type</label>
            </FormField>
            <FormField width={10}>
              <Dropdown
                fluid={true}
                onChange={handleChangeData}
                options={eligibilityTypeOptions}
                search={true}
                selection={true}
                name="eligibility_type"
                value={selectDetail?.eligibility_type}
              ></Dropdown>
            </FormField>
          </FormGroup>
        </Form>
      )}
    </div>
  );
};

export default React.memo(FormMobEditOrderDetail);
